export const SET_UNIQUE_OBJECTS_AND_VARS = 'SET_UNIQUE_OBJECTS_AND_VARS';
export const SET_UNIQUE_VAR_SELECTED = 'SET_UNIQUE_VAR_SELECTED';
export const CHANGE_UNIQUE_SELECTED_ALL = 'CHANGE_UNIQUE_SELECTED_ALL';
export const CHANGE_UNIQUE_OBJECT_SELECTED_ALL = 'CHANGE_UNIQUE_OBJECT_SELECTED_ALL';
